import {
  NITROFERT_BRAND_ROUTE,
  NITROFERT_DEFAULT_TITLE,
  NITROFERT_LOGO_ROUTE,
  RELEASE_NITROFERT_API_ROUTE,
  RELEASE_NITROFERT_PORTAL_LOGIN_URL,
  TESTING_NITROFERT_API_ROUTE,
  TESTING_NITROFERT_PORTAL_LOGIN_URL,
} from "../constantes";
import { InitData, RunMode, RunModes } from "../shared/BaseInit";

/** Configuración de la marca Nitrofert (producto Nitria) para la app
 *  Cliente: rutas de API, logo, marca, título y entrada por el portal de
 *  Nitria (el de producción en release; el de desarrollo en debug y testing).
 *  La comparten el punto de entrada de la app (`NitrofertCliente.ts`) y el de
 *  su página oculta de ingreso con contraseña (`NitrofertClienteInterno.ts`). */
export function fx_createNitrofertInitData(): InitData {
  return {
    testingBaseApiRoute: TESTING_NITROFERT_API_ROUTE,
    releaseBaseApiRoute: RELEASE_NITROFERT_API_ROUTE,
    logoRoute: NITROFERT_LOGO_ROUTE,
    brandRoute: NITROFERT_BRAND_ROUTE,
    defaultTitle: NITROFERT_DEFAULT_TITLE,
    brandId: "nitrofert",
    withRecuperarPassword: false,
    portalLoginUrl:
      RunMode === RunModes.Release
        ? RELEASE_NITROFERT_PORTAL_LOGIN_URL
        : TESTING_NITROFERT_PORTAL_LOGIN_URL,
  };
}
